<template>
  <div class="mask-layer" @click.stop="hide" v-if="showValidCode">
    <div class="d-box" @click.stop>
      <div class="title">
        <span>请输入下方人机校验码</span>
        <div class="icon-box" @click.stop="hide">
          <i class="icon"></i>
        </div>
      </div>
      <div class="content">
        <img :src="imgUrl" v-if="imgUrl" @click.stop="refreshImgCode" class="img-code">
        <div class="input">
          <div class="char-input" :class="{'char-input-focus': isFocus}">
            <div class="input-box">
              <input @focus="focusHandler" @blur="blurHandler" maxlength="4" type="text" class="input-txt" v-model="currentValue" />
            </div>
          </div>
        </div>
        <div class="btns">
          <button class="btn btn-ok" @click="confirm">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from 'libs/util';
import { getConfig } from 'config'

export default {
  props: {
    value: {
      type: Boolean,
      default: ''
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.showValidCode = newVal;
      }
      if (newVal) {
        this.refreshImgCode();
      }
    }
  },
  data() {
    return {
      imgUrl: '',
      isFocus: false,
      currentValue: '',
      showValidCode: this.value
    }
  },
  mounted() {
    this.refreshImgCode();
  },
  methods: {
    refreshImgCode() {
      this.imgUrl = `/api/passport/captcha?d=` + (+new Date());
    },
    clear() {
      this.currentValue = '';
      this.refreshImgCode();
    },
    confirm() {
      if (!this.currentValue) {
        this.$toast('请输入人机校验码!');
        return
      }
      this.$emit('confirm', this.currentValue);
    },
    hide() {
      this.showValidCode = false
      this.$emit('input', false);
    },
    focusHandler() {
      this.isFocus = true;
    },
    blurHandler() {
      this.isFocus = false;
    }
  }
}

</script>
<style lang="less" scoped>
.d-box {
  .img-code {
    display: block;
    margin: 0 auto 0;
    cursor: pointer;
  }
  .input {
    margin-top: 20px;
  }
  .char-input {
    align-items: center;
    .input-box {
      width: 200px;
      height: 40px;
      border: solid 1px #bbb;
      text-align: center;
      flex: 1;
      margin: 0 auto;
      .input-txt {
        width: 100%;
        height: 100%;
        line-height: 40px;
        border: 0;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        border: 0;
      }
    }
    .btn-act {
      margin: 20px auto 0;
      height: 50px;
      border-radius: 100px;
      width: 400px;
    }
  }
  .btns {
    .btn-ok {
      margin: 0;
    }
  }
}

</style>
